import "./TopicStartegyBuilder.scss";

import {
  Box,
  Card,
  CardHeader,
  InputAdornment,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomToast from "../../utils/cutomToast/CustomToast";
import Loader from "../../utils/loader/Loader";
import SearchFilled from "@mui/icons-material/Search";
import axios from "axios";
import { urlConstants } from "../../components/constants/globalConstants";
import { useNavigate } from "react-router-dom";

const CardHistory = forwardRef(({ con, nav, channel }: any, ref) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [jobHistory, setJobHistory] = useState<any>([]);
  const navigate = useNavigate();
  const firstTimeHistory = useRef(true);

  // first tab Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // first tab Handle rows per page change
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleJobHistory = async () => {
    try {
      setLoading(true);
      let response = await axios.get(`${urlConstants.PROMPT_URL}/job`);

      let finalRes = response.data;

      if (finalRes.jobs.length > 0) {
        setJobHistory(finalRes?.jobs);
      } else {
        setJobHistory([]);
      }
    } catch (error: any) {
      CustomToast(error?.response?.data?.detail[0]?.msg || error?.message, "error");
      setJobHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    refresh: () => {
      handleJobHistory();
    },
  }));

  useEffect(() => {
    if (firstTimeHistory.current) {
      handleJobHistory();
      firstTimeHistory.current = false;
    }
  }, [firstTimeHistory]);
  return (
    <Loader spinning={loading}>
      <Card className="card-container">
        <CardHeader
          className="card-header"
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box className="card-header-inner-history">
                <Typography
                  variant="h5"
                  sx={{
                    alignSelf: "stretch",
                    color: "rgba(0, 0, 0, 0.87) !important",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                  }}
                >
                  {con ? "History" : "Jobs"}
                </Typography>
              </Box>
              <Box className="search-control" sx={{ ml: 2 }}>
                <TextField
                  id="enter-jobName-search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ width: 512, height: 40 }}
                  placeholder="Search"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchFilled />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
          }
        />
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer>
            <Table className="table-history">
              <TableHead className="head-history">
                <TableCell className="header-cell-history">Job Name</TableCell>
                <TableCell className="header-cell-history">
                  Date & Time
                </TableCell>
                <TableCell></TableCell>
              </TableHead>
              {jobHistory.length > 0 &&
                jobHistory
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((job: any) => (
                    <TableRow className="row-history">
                      <TableCell className="header-cell-history">
                        {job.name}
                      </TableCell>
                      <TableCell className="header-cell-history">
                        {job.created_at}
                      </TableCell>
                      {!con && (
                        <TableCell
                          onClick={() => {
                            if (nav) {
                              navigate(
                                `/topic-startegy?JobId=${job.job_id}&Action=update`
                              );
                            }else if(channel){
                               navigate(`/channel-analyzer-main-page?JobId=${job.job_id}`);
                            } else {
                              navigate(`/blogs-main-page?JobId=${job.job_id}`);
                            }
                          }}
                        >
                          <ArrowForwardIcon
                            sx={{
                              opacity: 0.85,
                              color: "grey",
                              cursor: "pointer",
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
            </Table>
          </TableContainer>
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
            component="div"
            count={jobHistory.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Card>
    </Loader>
  );
});

export default CardHistory;
